const Actions = self => ({
  set: (min, max, string) => {
    self.min = min;
    self.max = max;
    self.string = string;
  },
});

export default Actions;
